import { useState } from "react";
import useApi from "../../api";
import { NXEyes } from "../../icons";
import { useDeleteConfirmation } from "../common";
import GenericSelectableTable from "../selectableTable";
import StockTransferDetailsView from "../../pages/stocks/StockTransferDetailsView";


interface StockTableProps {
    data: any;
    refresh: ()=>void;
}

function StockTransferTable({data, refresh}:StockTableProps) {
  const [stockDetailOpen, setStockDetailOpen] = useState(null);
  const {handleDelete}  = useDeleteConfirmation()
  const api = useApi()

  const columns = [
    { header: "ID", key: "node.dbId", render:(item:any)=>(
      <div className="text-base-300 text-sm">
        #ID {item.node.dbId}
      </div>
    )},
    { header: "From Warehouse", key: "node.fromWarehouse.name", },
    { header: "To Warehouse", key: "node.toWarehouse.name", },
    { header: "status", key: "node.status", },
    { header: "Actions", key: "actions", render: (item: any) => (
        <div className="flex gap-2">
            <button className="p-1" onClick={() => setStockDetailOpen(item.node.dbId)}>
             <NXEyes className="text-primary-400" />
            </button>
        </div>
    )},

  ]

  return (
    <div>
      <div className="overflow-x-auto">
        <GenericSelectableTable columns={columns} data={data}/>
      </div>
      {stockDetailOpen &&  <StockTransferDetailsView instance={stockDetailOpen} isOpen={stockDetailOpen ? true : false} onClose={()=>setStockDetailOpen(null)} refresh={refresh} /> }
    </div>
  )
}

export default StockTransferTable